<div class="status">
  <span class="spinner"></span>
  <span>{{ 'CALLS.MINUTES_DRAFTING' | translate }}</span>
</div>
<div class="page" aria-hidden="true">
  <div class="document">
    <div class="block title-block">
      <span class="bar heading document-title"></span>
      <span class="bar subtitle"></span>
    </div>
    <div class="block">
      <div class="row">
        <span class="bar heading label"></span>
        <span class="bar" style="width: 62%"></span>
      </div>
      <div class="row">
        <span class="bar heading label"></span>
        <span class="bar" style="width: 38%"></span>
      </div>
    </div>
    <div class="divider"></div>
    @for (item of items; track $index) {
      <div class="block item" [style.--delay]="$index * 0.08 + 's'">
        <div class="row">
          <span class="bar heading number"></span>
          <span class="bar heading" [style.width]="item.titleWidth"></span>
        </div>
        <div class="indented item-body">
          @for (paragraph of item.paragraphs; track $index) {
            <div class="lines">
              @for (width of paragraph; track $index) {
                <span class="bar" [style.width]="width"></span>
              }
            </div>
          }
          @if (item.bullets.length > 0) {
            <div class="lines indented">
              @for (width of item.bullets; track $index) {
                <div class="bullet">
                  <span class="dot"></span>
                  <span class="bar" [style.width]="width"></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="fade"></div>
</div>
